import type { ReactNode } from 'react';
import { Center, Stack, Text } from '@mantine/core';

type WorkspaceEmptyStateProps = {
  icon: ReactNode;
  message: string;
};

export function WorkspaceEmptyState({ icon, message }: WorkspaceEmptyStateProps) {
  return (
    <Stack align="center" gap="md">
      <Center
        w={58}
        h={58}
        c="terracotta.7"
        style={{ borderRadius: 18, backgroundColor: 'rgba(196, 90, 60, 0.1)' }}
      >
        {icon}
      </Center>
      <Text fw={800} ta="center">{message}</Text>
    </Stack>
  );
}
